import script from "./AppRegisterForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppRegisterForm.vue?vue&type=script&setup=true&lang=ts"

import "./AppRegisterForm.vue?vue&type=style&index=0&id=52982d90&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52982d90"]])

export default __exports__